import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appNumbersOnly]',
  standalone: false
})
export class NumbersOnlyDirective {

  private numberPattern = /[^0-9]/g; // Matches anything that is NOT a number

  constructor(private _el: ElementRef) {}

  @HostListener('input', ['$event']) onInputChange(event: InputEvent): void {
    const input = this._el.nativeElement as HTMLInputElement;
    const cleanedValue = input.value.replace(this.numberPattern, ''); // Remove non-numeric characters
    if (input.value !== cleanedValue) {
      input.value = cleanedValue; // Update the input value
      event.stopImmediatePropagation(); // Prevent further event propagation
    }
  }

}
